module.exports = __webpack_public_path__ + "static/media/27.357f4a29.mp3";